module.exports = __webpack_public_path__ + "img/calendar.25488e35.svg";